import React, { Component } from 'react';
import { arrayOf, shape, string, func, oneOf, number, oneOfType, bool } from 'prop-types';
import UserPrivilegeInfo from '../UserPrivilegeInfo';
import { OWNER, MANAGER, EDITOR, VIEWER, INHERIT } from '../../helpers/constant';
import { get } from 'lodash';

import styles from './styles.scss';

export default class AccessControlList extends Component {
  static propTypes = {
    users: arrayOf(shape({
      id: oneOfType([string, number]).isRequired,
      firstName: string,
      lastName: string,
      subtitle: string,
      profileImage: string,
      permission: oneOf([OWNER, MANAGER, EDITOR, VIEWER, INHERIT]),
    })).isRequired,
    inCampaignDialog: bool,
    onChange: func.isRequired
  }


  handleChange = ({id: index, permission}) => {
    const { onChange, users } = this.props;
    const userId = get(users[index], 'id', '') ;
    userId && onChange && onChange({userId, permission});
  }

  handleDelete = (index) => {
    const { users, onChange } = this.props;
    const userId = get(users[index], 'id', '');
    userId && onChange && onChange({userId, permission:null});
  }

  render() {
    const { users, inCampaignDialog } = this.props;

    return (
      <div data-test="accessControlList" className={styles.accessControlList}>
        {users && users.map((user, index) => {
          const key = `${index}_${JSON.stringify(user)}`;
          return (
            <div data-test="accessControlItem" className={styles.listRow} key={key}>
              <UserPrivilegeInfo
                {...user}
                id={index}
                disableSetOwner={inCampaignDialog}
                onChange={this.handleChange}
                onDelete={this.handleDelete}
              />
            </div>
          )
        })}
      </div>
    )
  }
}
